import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { useContext, useEffect } from "react";
import { UserContext } from "../../context";
import { isValidSession } from "../../utils/sessionStorage";

const InspectorLayout = () => {
  const location = useLocation();
  const nav = useNavigate();

  const { actions: ua } = useContext(UserContext);

  useEffect(() => {
    if (!ua.hasRole("inspector.app")) {
      nav("/");
    }
  }, []);

  if (!isValidSession()) return null;

  return (
    <>
      <Outlet />
    </>
  );
};

export default InspectorLayout;
